export enum Actions {
  a_ping= "ping",
  b_trace = "traceroute",
  c_route = "route"
}
